import classnames from 'classnames';
import React from 'react';
import { WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { ButtonIcon } from 'src/app/components/Button/ButtonIcon';
import { IconArrowDownSlim } from 'src/app/components/Icon/IconArrowDownSlim';
import { IconArrowUpSlim } from 'src/app/components/Icon/IconArrowUpSlim';
import { SortItem } from 'src/app/components/Sort/SortItem';
import { SORT, EnumSort } from 'src/app/constants/sort';
import { withIntl } from 'src/app/helpers/locale';
import { withStyles } from 'src/app/helpers/styles';

const defaultOptions = [{
  label: 'label.sort.popular',
  value: SORT.POPULAR
}, {
  label: 'label.sort.newest',
  value: SORT.NEWEST
}];

type MyInjectedProps = InjectedIntlProps;

interface MyOwnProps {
  handleSortByChanged: (value: string) => void;
  sortBy: string;
  className?: string;
  options?: {
    label: string;
    value: EnumSort;
  }[];
}

type MyProps = MyOwnProps & MyInjectedProps;

interface MyState {
  showDropdown: boolean;
}

@withIntl()
@withStyles({
  base: [require('./Sort.base.scss')],
  desktop: [require('./Sort.desktop.scss')]
})
class MyClassSort extends React.Component<MyProps, MyState> {
  private sortByDiv: HTMLDivElement;

  constructor(props: MyProps) {
    super(props);

    this.state = {
      showDropdown: false
    };

    this.setSortByReference = this.setSortByReference.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.getSelectedSortBy = this.getSelectedSortBy.bind(this);
  }

  render(): JSX.Element {
    return (
      <div className={classnames('position-relative fs-10 fs@md-12 fw-normal ls-2 bg-black-dark radius-small sort', this.props.className)} ref={this.setSortByReference}>
        <div className="w-100 bg-transparent sort__select" onClick={this.toggleDropdown}>
          <div className="tt-uppercase pl-12 pr-24 pl@md-16 pr@md-28 fg-white cursor-pointer">
            {this.getSelectedSortBy()}
            <ButtonIcon className="position-absolute sort__icon" icon={this.state.showDropdown ? IconArrowUpSlim : IconArrowDownSlim} modifier="transparent" />
          </div>
          {this.state.showDropdown && this.renderDropdown()}
        </div>
      </div>
    );
  }

  private getSelectedSortBy(): string {
    const { intl: { formatMessage }, sortBy, options } = this.props;
    let label = '';
    (options ?? defaultOptions).forEach((option) => {
      if (option.value === sortBy) {
        label = option.label;
      }
    });
    return formatMessage({ id: label });
  }

  private renderDropdown(): JSX.Element {
    return <div className="pt-6 pb-16 bg-black-light">{this.renderDropdownItem()}</div>;
  }

  private renderDropdownItem(): JSX.Element[] {
    const { intl, sortBy, handleSortByChanged, options } = this.props;
    return (options ?? defaultOptions).map((option, index) => {
      const classname = 'tt-capitalize ls-normal fw-normal fs-14 px-16 sort__select-item cursor-pointer';
      const selected = (sortBy === option.value) ? ' fg-gray' : ' fg-white';
      return (
        <SortItem
          key={index}
          label={option.label}
          value={option.value}
          handleSortByChanged={handleSortByChanged}
          classname={classname + selected}
          intl={intl}
        />
      );
    });
  }

  private setSortByReference(ref: HTMLDivElement): void {
    this.sortByDiv = ref;
  }

  private toggleDropdown(): void {
    if (this.state.showDropdown) {
      document.removeEventListener('click', this.handleOutsideClick, true);
    } else {
      document.addEventListener('click', this.handleOutsideClick, true);
    }
    this.setState({ showDropdown: !this.state.showDropdown });
  }

  private handleOutsideClick(e: Event): void {
    if (this.sortByDiv && !this.sortByDiv.contains(e.target as HTMLElement)) {
      this.toggleDropdown();
      e.stopPropagation();
    }
  }
}

export const Sort = MyClassSort as React.ComponentClass<MyOwnProps>;
